import Certificado from "./certificado/Certificado";
export default class Empresa {
  constructor(
    cnpj = "",
    razao = "",
    grupo,
    apelido,
    ie,
    ccm,
    endereco,
    bairro,
    complemento,
    cep,
    municipio,
    uf,
    codMun,
    faturamento,
    colaboradores,
    certificado,
    nfeTask,
    cteTask,
    enviaEmails,
    _id,
    tknIntegracao,
    dtReg,
    bloqueada
  ) {
    this.cnpj = cnpj;
    this.razao = razao;
    this.grupo = grupo;
    this.apelido = apelido;
    this.endereco = endereco;
    this.bairro = bairro;
    this.complemento = complemento;
    this.ccm = ccm;
    this.ie = ie;
    this.cep = cep;
    this.municipio = municipio;
    this.uf = uf;
    this.codMun = codMun;
    this.colaboradores = colaboradores;
    this.faturamento = faturamento;
    this.certificado = certificado;

    this.dtReg = dtReg ? new Date(dtReg) : new Date();
    this.bloqueada = bloqueada

    let bvenc = false;
    if (certificado != undefined) {
      if (
        certificado.validade == undefined ||
        new Date() > new Date(certificado.validade)
      ) {
        bvenc = true;
      }
      this.certificado["validade"] = {
        data:
          certificado.validade != undefined
            ? new Date(certificado.validade)
            : undefined,
        venc: bvenc
      };
    } else {
      this.certificado = certificado;
    }
    this.nfeTask = nfeTask;
    this.cteTask = cteTask;
    this.enviaEmails = enviaEmails;
    this._id = _id;
    this.tknIntegracao = tknIntegracao;
  }
}



// WEBPACK FOOTER //
// ./src/domain/conta/empresa/Empresa.js